import reqwest from 'reqwest';
import { apiUrl } from './config';

export default {
  isInGeoFenceAttendance(data, opt) {
    return reqwest({
      url: `${apiUrl}/customer-api/api/worker/isInGeoFenceAttendancePosition`,
      data,
      ...opt,
    });
  },
  isInGeoFenceAttendancePosition(data, opt) {
    return reqwest({
      url: `${apiUrl}/customer-api/api/location/project/query/isInGeoFenceAttendancePosition`,
      method: 'post',
      data: JSON.stringify(data),
      contentType: 'application/json',
      ...opt,
    });
  },
};
